(function($) {
  var $leftArea = $("#event_scroller_left"),
    $rightArea = $("#event_scroller_right"),
    $leftDate = $("#date_scroller_left"),
    $rightDate = $("#date_scroller_right"),
    tId = null,
    time = 300,
    position = 0,
    numEvent = $(".event").length,
    eventWidth = parseInt($(".event").css("width")),
    eventWidthTotal = numEvent * eventWidth,
    relativePosition = parseInt($(".events").css("width")) - eventWidthTotal;
  $(window).on("resize", function(e) {
    $(".events, .dates").css("left", "0px");
    ($leftArea = $("#event_scroller_left")),
      ($rightArea = $("#event_scroller_right")),
      ($leftDate = $("#date_scroller_left")),
      ($rightDate = $("#date_scroller_right")),
      (tId = null),
      (time = 300),
      (position = 0),
      (numEvent = $(".event").length),
      (eventWidth = parseInt($(".event").css("width"))),
      (eventWidthTotal = numEvent * eventWidth),
      (relativePosition =
        parseInt($(".events").css("width")) - eventWidthTotal);
  });
  if ($(window).width() > 767) {
    $leftArea.on("click", function(e) {
      e.preventDefault();
      if ($(this).hasClass("disable")) {
        return;
      }
      position = parseInt($(".events").css("left"));
      position = position + parseInt(eventWidth);
      if (position > 0) {
        position = 0;
      }
      console.log(position);
      $(".events, .dates").css("left", position + "px");
    });

    $rightArea.on("click", function(e) {
      e.preventDefault();
      if ($(this).hasClass("disable")) {
        return;
      }
      position = parseInt($(".events").css("left"));
      position = position - parseInt(eventWidth);
      if (position < relativePosition) {
        position = relativePosition;
      }
      console.log(position);
      $(".events, .dates").css("left", position + "px");
    });

    $leftDate.on("click", function(e) {
      e.preventDefault();
      if ($(this).hasClass("disable")) {
        return;
      }
      position = parseInt($(".events").css("left"));
      position = 3 * eventWidth + position;
      if (position > 0) {
        position = 0;
      }
      $(".events, .dates").css("left", position + "px");
    });
    $rightDate.on("click", function(e) {
      e.preventDefault();
      if ($(this).hasClass("disable")) {
        return;
      }
      position = parseInt($(".events").css("left"));
      position = -1 * (3 * eventWidth - position);
      if (position + (eventWidthTotal - eventWidth * 5) <= 0) {
        position = -1 * (eventWidthTotal - eventWidth * 5);
      }
      $(".events, .dates").css("left", position + "px");
    });

    $(".event").on("click", function(e) {
      var $this = $(this);
      e.preventDefault();
      var index = $("div.event").index(this);
      if ($(this).hasClass("expanded")) {
        $(".events").css("left", position + "px");
        $this.removeClass("expanded");
        $leftArea.removeClass("disable");
        $rightArea.removeClass("disable");
        $leftDate.removeClass("disable");
        $rightDate.removeClass("disable");
      } else {
        $this.addClass("expanded");
        $leftArea.addClass("disable");
        $rightArea.addClass("disable");
        $leftDate.addClass("disable");
        $rightDate.addClass("disable");
        $(".events").css("left", "-" + index * eventWidth + "px");
      }
    });

    $(".date").on("click", function(e) {
      e.preventDefault();
      if ($(this).hasClass("disable")) {
        return;
      }
      var index = $("div.date").index(this);
      var date = $("p", this).html();
      if ($('.event[data-year="' + date + '"]').hasClass("expanded")) {
        $(".events").css("left", position + "px");
        $('.event[data-year="' + date + '"]').removeClass("expanded");
        $leftArea.removeClass("disable");
        $rightArea.removeClass("disable");
        $leftDate.removeClass("disable");
        $rightDate.removeClass("disable");
      } else {
        $(".event").removeClass("expanded");
        $('.event[data-year="' + date + '"]').addClass("expanded");
        $(".events").css("left", "-" + index * eventWidth + "px");
        $leftArea.addClass("disable");
        $rightArea.addClass("disable");
        $leftDate.addClass("disable");
        $rightDate.addClass("disable");
      }
    });
  }
})(jQuery);
